<template>
  <div>
    <side-popup title="余额充值" :padding="padding" :popupVisible="paymentOpen" @onClose="handleClose">
      <div class="PopPayment">
        <div style="margin: auto auto 15px; text-align: center">
          <div class="scRadio">
            <div class="scRadio-item" :class="{'scRadio-item-a': payType=='online'}" @click="changeType('online')">在线充值</div>
            <div class="scRadio-item" :class="{'scRadio-item-a': payType!='online'}" @click="changeType('cdk')">CDK充值</div>
          </div>
        </div>

        <div v-if="payType=='online'" class="pay-ment">
          <div v-if="rechargeList.length" class="youhui pay-item flex flex-ac">
            <div class="y-l t">优惠已启用</div>
            <div class="y-r flex-1">
              <i class="el-icon-message-solid"></i>
              <span>{{ rechargeList[0].message }}</span>
            </div>
          </div>
          <div class="">
            <div class="pay-item ment-money flex">
              <div class="t flex-0">充值金额</div>
              <div class="ment-list flex-1">
                <ul>
                  <li v-for="(item, index) in list" :key="index" @click="zhifuMoney(index,item)">
                    <div class="item-li" :class="{'li-active':payIndex==index}">
                      <img src="@/assets/images/money-box.png" alt="" srcset="" class="money-box-img">
                      <div class="flex flex-ac flex-jc">
                        <div class="list-con">
                          <img src="@/assets/images/money.png" class="money-img" />
                          <span>{{ item.gold_coins }}</span>
                        </div>
                        <div v-if="item.silver_coins" class="list-con">
                          <img src="@/assets/images/masonry.png" class="masonry-img" />
                          <span> {{ item.silver_coins }}</span>
                        </div>
                      </div>
                      <div v-if="payIndex==index" class="dui">
                        <div class="san" />
                        <i class="el-icon-check" />
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="pay-item price flex flex-ac">
              <div class="t">支付金额</div>
              <div class="red">
                <span>{{ payObj.price }}</span> 元</div>
            </div>
            <div class="pay-item money-d flex flex-ac">
              <span class="t">您将获得</span>
              <div class="flex flex-ac">
                <div class="level-item level-money flex flex-ac">
                  <img src="@/assets/images/money.png" class="money-img" />
                  <strong>{{ payObj.gold_coins }}</strong>
                </div>
                <div v-if="payObj.silver_coins" class="level-item level-masonry flex flex-ac">
                  <img src="@/assets/images/masonry.png" class="masonry-img" />
                  <strong>+{{ payObj.silver_coins }}</strong>
                </div>
              </div>
            </div>
            <div class="pay-item pay-way flex">
              <span class="t">付款方式</span>
              <div class="flex flex-w flex-1">
                <div v-for="item in result.pay_types" :key="item.key" :label="item.key" class="pay-witem flex flex-jc flex-ac" :class="{'pay-witem-active':item.key==pay_types}" @click="selTypes(item)">
                  <img v-if="item.icon" :src="item.icon" alt="" srcset="">
                  <span>{{ item.name }}</span>
                  <div v-show="item.key==pay_types" class="dui">
                    <div class="san" />
                    <i class="el-icon-check" />
                  </div>
                </div>
              </div>

            </div>
            <div v-if="result.use_method==2" class="btn-w-r-bg" @click="payTiaochange">
              <div class="btn-c-r">立即充值</div>
            </div>
            <div v-if="result.use_method==1" class="qrcode-box" :class="{'qrcode-box-show':pay_types!=''}">
              <div id="qrcode" ref="qrcode" class="qrcode" />
              <div v-if="pay_types!=''" class="tip">
                <div>{{ getName(pay_types) }}</div>
                <div>扫一扫继续付款</div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="pay-ment">
          <div>
            <div class="pay-item ment-money flex" style="align-items: center">
              <div class="t">充值码:</div>
              <div>
                <input type="text" v-model="password" style="width: 300px;height: 30px; padding: 0 5px" placeholder="请输入充值码">
              </div>
            </div>
            <div class="ment-btn">
              <el-button class="el-btn" :disabled="loading" :style="{ 'background-color': loading ? '#949493' : '#e9b10e' }" @click="handleRecharge('wechat')">
                <i v-if="loading" class="el-icon-loading"></i>立即充值
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </side-popup>
    <side-popup title="支付结果" width="350px" :popupVisible="showBox" @onClose="showBox=false">
      <div class="tan-pay">
        <div class="pay-stutus">
          <div class="title">
            <i class="el-icon-success"></i>
            <div class="t">充值成功</div>
          </div>
          <div class="shop">
            <div class="fkex flex flex-jc flex-ac">
              <div class="level-item level-money flex flex-ac">
                <img src="@/assets/images/money.png" class="money-img" />
                <strong>{{result.goods.gold_coins }}</strong>
              </div>
              <div class="level-item level-masonry flex flex-ac">
                <img src="@/assets/images/masonry.png" class="masonry-img" />
                <strong>{{result.goods.silver_coins }}</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </side-popup>
    <audio controls ref="notify" class="audio" style="display: none;">
      <source src="@/assets/audio/open_box2.mp3" />
    </audio>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import { getToken } from '@/api/auth'
import { mapGetters } from 'vuex'
import SidePopup from "@/g-components/side-black-popup.vue";

export default {
  components: {
    SidePopup
  },
  data() {
    return {
      rechargeList: [],
      password: '',
      showBox: false,
      // enter 充值的金额可以手动输入，default 自定义的数据
      payNext: 'default',
      list: [{
        mode: 1,
        gold_coins: '5.00',
        silver_coins: 0
      }, {
        mode: 1,
        gold_coins: '10.00',
        silver_coins: 0
      }, {
        mode: 1,
        gold_coins: '20.00',
        silver_coins: 0
      }, {
        mode: 1,
        gold_coins: '50.00',
        silver_coins: 0
      }, {
        mode: 1,
        gold_coins: '100.00',
        silver_coins: 0
      }, {
        mode: 1,
        gold_coins: '150.00',
        silver_coins: 0
      }],
      payIndex: -1,
      price: '',
      payObj: { price: 0, gold_coins: 0, silver_coins: 0, mode: 1, key: '', coins_rate: '', recharge_rate: '', },
      coins_rate: '',
      recharge_rate: '',
      payBox: false,
      result: {
        goods: {
          silver_coins: 0,
          gold_coins: 0
        },
        pay_types: [],
        use_method: 1,
        user: { name: '', id: '' }
      },
      pay_types: '',
      order_sn: '',
      timer: '',
      loading: false,
      payType: "online",
      rmb: 0,
      qrCode: '',
      ratioList: [],
      padding: '0 30px'
    };
  },
  computed: {
    ...mapGetters([
      'paymentOpen'
    ])
  },
  watch: {
    paymentOpen(newVal) {
      if (newVal) {
        if (this.$store.state.userInfo && this.$store.state.userInfo.sure_name == '') {
          this.$store.commit("setPersonalOpen", 'idCard')
          return
        }

        this.amountList()
      } else {
        if (this.$refs.qrcode) {
          this.$refs.qrcode.innerHTML = ""
        }
        this.pay_types = ''
        if (this.timer) {
          clearInterval(this.timer)
        }
      }
    }
  },
  created() {
    // 如果未认证，那么跳到认证
    if (this.paymentOpen) {
      this.amountList()
    }
    this.padding = window.innerWidth < 540 ? '0 10px' : '0 30px'
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    changeType(type) {
      this.payType = type
    },
    // cdk 兑换
    handleRecharge() {
      if (this.password == '') {
        this.$message.warning('请输入充值码!')
        return false
      }
      this.$doPost("/api/member.Recharge/cdk", {
        ApiToken: getToken(),
        password: this.password
      }).then((res) => {
        this.$message.success(res.msg)
        this.loading = false
        this.password = ''
        this.$store.dispatch('getInfo')
      }).catch(() => {
        this.loading = false
      })
    },
    getName(key) {
      let name = ''
      this.result.pay_types.map(item => {
        if (item.key == key) {
          name = item.name
        }
      })
      return name
    },
    // 获取充值列表
    amountList() {
      this.$doGet("/api/hall.Recharge/getRechargeSetting").then((res) => {
        this.payIndex = -1
        this.list = res.data
        this.zhifuMoney(0)
      }).catch(() => { })
      this.$doGet("/api/hall.Recharge/getRechargePreferential").then((res) => {
        console.log(res)
        this.rechargeList = res
        // this.list = res.data
      }).catch(() => { })
    },
    handleClose() {
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = ""
      }
      this.pay_types = ''
      this.result.use_method = 1
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.$store.commit("setPaymentOpen", false)
    },
    // 选中
    zhifuMoney(index) {
      if (this.payIndex == index) {
        return false
      }
      this.payIndex = index
      this.payObj = this.list[index]
      this.payAction()
      if (this.payObj.mode == 2) {
        this.coins_rate = this.payObj.coins_rate
        this.recharge_rate = this.payObj.recharge_rate
      }
    },
    jisuan(type) {
      let j = 0
      if (type == 'zhuan') {
        j = this.recharge_rate
      } else {
        j = this.coins_rate
      }
      // console.log(j, this.price * j)
      if (this.price) {
        return Math.floor((this.price * j) / 100)
      } else {
        return 0
      }
    },
    payAction() {
      if (this.payIndex == -1) {
        this.$message({
          message: "请选择支付项",
          type: "warning",
        });
        return false
      }
      let obj = {
        key: this.payObj.key,
        price: this.payObj.price
      }
      if (this.payObj.mode == 2) {
        if (this.price == '') {
          this.$message({
            message: "请输入充值金额",
            type: "warning",
          });
          return false
        }
        obj.price = this.price * 1
      }
      this.pay_types = ''
      this.qrCode = ''
      this.$doGet("/api/hall.Recharge/getRechargePaySetting", obj).then((res) => {
        res.data.use_method = ''
        this.result = res.data
        this.$refs.qrcode.innerHTML = ""
      }).catch(() => { })
    },
    selTypes(item) {
      if (item.key == this.pay_types) return false;
      this.pay_types = item.key
      if (this.$refs.qrcode) {
        this.$refs.qrcode.innerHTML = "";
      }
      this.result.use_method = item.use_method
      if (this.result.use_method == 1) {
        this.paychange()
      }
    },
    paychange(e) {
      if (this.pay_types == '') {
        this.$message.warning('请选择支付方式!')
        return false
      }
      this.$doGet("/api/hall.Recharge/getPayOrder", {
        key: this.result.goods.key,
        pay_type: this.pay_types
      }).then((res) => {
        // 这边开启定时器
        this.order_sn = res.data.order_sn
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = setInterval(() => {
          this.checkOrderStatus()
        }, 1000 * 5)
        this.$refs.qrcode.innerHTML = "";
        new QRCode("qrcode", {
          width: 150,
          height: 150,
          logoWidth: 40,
          logoHeight: 40,
          text: res.data.qr_url,
        });
        // this.qrCode = res.data.qr_url
      }).catch(() => { })
    },
    payTiaochange() {
      if (this.pay_types == '') {
        this.$message.warning('请选择支付方式!')
        return false
      }
      this.$doGet("/api/hall.Recharge/getPayOrder", {
        key: this.result.goods.key,
        pay_type: this.pay_types
      }).then((res) => {
        this.handleClose()
        window.location.href = res.data.qr_url
      }).catch(() => { })
    },
    isMobileDevice() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera
      // 这些表达式检查设备是否为iPhone、Android、Windows Phone等
      return /android|iphone|ipad|ipod|blackberry|windows phone/i.test(userAgent.toLowerCase())
    },
    // if (isMobileDevice()) {
    //     console.log('访问设备为手机端');
    // } else {
    //     console.log('访问设备为PC端');
    // }

    //充值送多少
    // getRatio() {
    //   this.$axios.get("index/User/giveAboutRecharge").then((res) => {
    //     let data = res.data;
    //     console.log(data);
    //     if (data.status == 1) {
    //       this.ratioList = data.data;
    //     }
    //   });
    // },
    //input框
    getInput(value) {
      //  /^(0\.0[1-9]|0\.[1-9]\d|[1-9]\d?(\.\d\d)?|[1-4]\d\d(\.\d\d)?|500)$/
      if (value == "") {
        this.list[6].money = "";
        this.list[6].rmb = 0;
      } else {
        this.list[6].money = value;
        this.list[6].rmb = (value * this.rmb).toFixed(2);
      }
      value = Number(value);

      let money = Number(this.ratioList.money);
      let limit = Number(this.ratioList.limit);
      if (money > 0 && limit > 0) {
        if ((value >= money) && (value <= limit)) {
          this.setTrue()
        } else {
          this.setFalse()
        }
      } else if (money == 0 && limit == 0) {
        this.setTrue()
      } else if (money > 0 && limit == 0) {
        console.log(value >= money);
        if ((value >= money)) {
          this.setTrue()
        } else {
          this.setFalse()
        }
      } else if (money == 0 && limit > 0) {
        if (value <= limit) {
          this.setTrue()
        } else {
          this.setFalse()
        }
      } else {
        this.setFalse()
      }
    },
    pay(type) {
      //console.log(this.$store.state.id,this.$store.state.mobile)
      let money = 0;
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].state) {
          money = this.list[i].money;
        }
      }

      let _this = this;
      let data = {
        mode: type,
        money: money,
        player_id: this.$store.state.id,
        mobile: this.userInfo.mobile,
      };
      _this.$axios.post("/index/Pay/recharge", data).then((res) => {
        let data = res.data;
        this.loading = false;
        if (data.status == 1) {
          // window.location.href = res.data.data;
          // this.$refs.qrcode.innerHTML = "";
          this.payBox = true;
          this.loading = false;

          this.$nextTick(() => {
            const qrCode = new QRCode("qrcode", {
              width: 160,
              height: 160,
              text: res.data.data,
            });
          });
        } else {
          this.$message({
            message: res.data.msg,
            type: "warning",
          })
        }
      });
    },
    checkOrderStatus() {
      this.$doGet("/api/channel.Payment/getPaymentStatus", {
        order_sn: this.order_sn
      }).then((res) => {
        if (res.data.status == 3) {
          this.handleClose()
          this.showBox = true
          this.$refs.notify.play()
          clearInterval(this.timer)
          this.$store.dispatch('getInfo')
        }
      }).catch(() => { })
    },
    saveImg() {
      var canvasData = this.$refs.qrcode.getElementsByTagName("canvas");
      var a = document.createElement("a");
      var event = new MouseEvent("click");
      a.href = canvasData[0].toDataURL("image/png");
      a.download = "支付二维码";
      a.dispatchEvent(event);
    },
    weixinMoney(index) {
      for (let i = 0; i < this.list.length; i++) {
        this.list[i].state = false;
      }
      this.list[index].state = true;
    }
  },
};
</script>

<style lang="less" scoped>
.PopPayment {
  color: #fff;
  .pay-ment {
    padding: 0 15px 15px;
    .pay-item {
      margin-bottom: 15px;
      .t {
        font-weight: bold;
        margin-right: 20px;
        font-size: 16px;
      }
    }
    .youhui {
      box-sizing: border-box;
      margin-bottom: 15px;
      .y-r {
        height: 36px;
        background: #ffc400;
        border-radius: 4px;
        color: #2b2e3c;
        font-weight: bold;
        display: flex;
        align-items: center;
        padding-left: 24px;
        margin-left: -10px;
        i {
          font-size: 18px;
          color: #ff3535;
          margin-right: 8px;
        }
      }
    }
    .ment-money {
      .ment-list {
        ul {
          display: flex;
          width: calc(100% + 10px);
          flex-wrap: wrap;
          margin: -5px;
          li {
            padding: 5px;
            width: 200px;
            box-sizing: border-box;
            .item-li {
              position: relative;
              font-weight: bold;
              font-size: 18px;
              border-radius: 8px;
              box-sizing: border-box;
              background: linear-gradient(180deg, #3b2d1b 0%, #49451f 100%);
              border-radius: 8px;
              border: 1px solid #835a03;
              text-align: center;
              padding: 10px;
              overflow: hidden;
              .money-box-img {
                width: 80px;
                height: auto;
                margin-bottom: 10px;
              }
              &.li-active {
                border: 1px solid #ffc400;
              }
              .list-con {
                display: flex;
                align-items: center;
                justify-content: center;
                .masonry-img {
                  margin-left: 4px;
                }
              }
              .dui {
                color: #fff;
                position: absolute;
                bottom: 0;
                right: 10px;
                width: 10px;
                height: 20px;
                font-weight: bold;
                font-size: 12px;
                line-height: 20px;
                .san {
                  width: 0;
                  height: 0;
                  border-right: 20px solid #ffc400;
                  border-top: 20px solid transparent;
                }
                .el-icon-check {
                  position: absolute;
                  top: 6px;
                  right: -12px;
                  font-weight: bold;
                  font-size: 14px;
                  color: #2b2e3c;
                }
              }
            }
            .list-warp {
              .list-input {
                // line-height: 59px;
                // font-size: 14px;
                // color: #848492;
                padding: 0 4px;
                margin-top: 9px;
                input {
                  background: transparent;
                  width: 100%;
                  font-size: 16px;
                  border: 0;
                  height: 30px;
                  color: #fff;
                }
              }
              .list-bot {
                text-align: center;
                margin-top: 10px;
                font-size: 14px;
                color: #848492;
                white-space: nowrap;
              }
            }

            .ment-state {
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              border-radius: 5px;
              border: 1px solid #e9b10e;
            }

            .give {
              position: absolute;
              top: 1px;
              left: 0;
              width: 100%;
              height: 30px;
              line-height: 30px;
              margin-left: 1px;
              background-color: #e9b10e;
              color: #1a1c24;
              font-size: 12px;
              text-align: center;
              border-top-right-radius: 5px;
              border-top-left-radius: 5px;
            }
          }

          .list-li {
            // padding: 40px 20px 20px 20px;
          }

          li:hover {
            cursor: pointer;
          }
        }
      }
    }
    .price {
      margin-bottom: 4px;
      .red {
        margin: 0 4px;
        font-size: 20px;
        font-weight: bold;
        color: #ff3535;
      }
    }
    .money-d {
      margin-bottom: 4px;
      .level-item {
        font-size: 20px;
        color: #ffc400;
        margin-left: 8px;
        &.level-masonry {
          color: #00f7ff;
        }
      }
    }
    .pay-way {
      // margin-bottom: 4px;
      .pay-witem {
        padding: 0 20px;
        height: 40px;
        background: linear-gradient(180deg, #3b2d1b 0%, #49451f 100%);
        border-radius: 4px;
        margin-right: 15px;
        cursor: pointer;
        box-sizing: border-box;
        &.pay-witem-active {
          border: 2px solid #ffc400;
        }
        &:last-child {
          margin-right: 0;
        }
        img {
          width: 20px;
          height: auto;
          margin-right: 8px;
        }
        .dui {
          color: #fff;
          position: absolute;
          bottom: 0;
          right: 10px;
          width: 10px;
          height: 20px;
          font-weight: bold;
          font-size: 12px;
          line-height: 20px;
          .san {
            width: 0;
            height: 0;
            border-right: 20px solid #ffc400;
            border-top: 20px solid transparent;
          }
          .el-icon-check {
            position: absolute;
            top: 6px;
            right: -12px;
            font-weight: bold;
            font-size: 14px;
            color: #fff;
          }
        }
      }
    }
    .qrcode-box {
      padding: 15px;
      width: 150px;
      margin: 0px auto 0;
      border-radius: 4px;
      .qrcode {
        width: 150px;
        height: 150px;
      }
      .tip {
        font-size: 12px;
        color: #2b2e3c;
        text-align: center;
        margin-top: 4px;
      }
      &.qrcode-box-show {
        background: #fff;
      }
    }
    .ment-btn {
      // margin-top: 30px;
      padding: 30px 0;
      // display: flex;
      // justify-content: center;
      text-align: center;
      .el-btn {
        padding: 12px 22px;
        font-size: 16px;
        color: #1a1c24;
        background-color: #e9b10e;
        border-radius: 5px;
        font-weight: 600;
      }

      /*span:hover {
        cursor: pointer;
      }*/
    }
    .btn-w-r-bg {
      width: 200px;
      margin-top: 20px;
    }
  }
}
.tan-pay {
  .pay-stutus {
    text-align: center;
    .el-icon-success {
      color: #13ce66;
      font-size: 70px;
      margin-top: 20px;
    }
    .t {
      font-size: 24px;
      color: #fff;
      // font-weight: bold;
      margin: 10px 0 20px;
    }
    .fkex {
      .level-item {
        font-size: 20px;
        color: #ffc400;
        margin-left: 8px;
        &.level-masonry {
          color: #00f7ff;
        }
      }
    }
  }
}
// ::v-deep .el-dialog__body {
//   padding: 0 15px 20px !important;
// }
</style>
